import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import {
  FormItem,
  type ErrorMessageType,
} from "@freightsimple/ui-core/FormLayout/FormItem";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { SharedDedicated } from "@freightsimple/generated-dashboard-openapi-client/models/SharedDedicated";

interface SharedDedicatedDropdownProps {
  value: SharedDedicated | undefined;
  onChange: (newValue: SharedDedicated | undefined) => void;
  enabled: boolean;
  errorMessage?: ErrorMessageType | undefined;
  forceValidation?: boolean | undefined;
}

const options = [
  {
    value: SharedDedicated.Shared,
    label: "Shared (LTL/Volume)",
  },
  {
    value: SharedDedicated.Dedicated,
    label: "Dedicated / Exclusive Use",
  },
  {
    value: SharedDedicated.Either,
    label: "Either",
  },
];

export function BookShipmentSharedDedicatedDropdown(
  props: SharedDedicatedDropdownProps,
) {
  return (
    <ShowFormErrors show={props.forceValidation ?? false}>
      <FormItem error={props.errorMessage} fillWidth>
        <Dropdown
          value={props.value}
          onChange={(v) => props.onChange(v as SharedDedicated)}
          options={options}
          placeholder="Please Select"
          disabled={!props.enabled}
          width="full"
        />
      </FormItem>
    </ShowFormErrors>
  );
}
